import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { ClientExperienceNoteOverride } from 'Resources/Note';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';

const styles = () => ({
  root: {
  },
});

function TimelineNotes({ classes, ...rest }) {
  const { householdResource } = useSimpleHousehold();
  const [noteResource, setNoteResource] = React.useState();

  React.useEffect(() => {
    async function fetchNote() {
      const link = householdResource.relationship('notes').link('related');
      const collection = await link.get({
        metaOverrideSet: ClientExperienceNoteOverride,
        params: {
          noteType: 'clientExperience',
        },
      });

      if (collection.resources().list().length === 0) {
        collection.create({
          addToCollection: true,
          metaOverrideSet: ClientExperienceNoteOverride,
        });
      }
      const [nextNote] = collection;
      nextNote.attr('noteType', 'clientExperience');

      setNoteResource(nextNote);
    }
    if (householdResource) {
      fetchNote().catch(e => displayErrorMessage(e, 'Failed to fetch note'));
    }
  }, [householdResource?.id()]);

  const getContent = () => (
    <MetaFormInline
      className={classes.noteForm}
      resource={noteResource}
    />
  );
  return (
    <div className={classNames(classes.root)} {...rest}>
      { noteResource && getContent() }
    </div>
  );
}
TimelineNotes.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TimelineNotes);
